<app-loading-spinner *ngIf="!unitDetails;else main_content"></app-loading-spinner>
<ng-template #main_content>
  <div class="mb-2">
    <div class="d-flex align-items-center justify-content-between my-4">
      <div class="d-flex align-items-center">
        <h2 class="mb-0"> Cycle {{unitNumber}} Overview</h2>
      </div>
    </div>

  </div>
  <div class="ml-4 mr-4">
    <div class="row header my-4">
      <div class="col-md-12">
        <div class="d-flex justify-content-between">
          <div>
            <span class="detail-name mr-3">Started on</span>
            <span>{{ unitDetails.StartedOn | date }}</span>
          </div>
          <div>
            <span class="ml-5 mr-3 grey-text-color">Cycle {{unitNumber}} Time spent</span>
            {{ displayTime(unitDetails.TimeSpent) }}
          </div>
        </div>
      </div>
    </div>
    <div>
      <hr>
      <div *ngIf="mappedDescriptions.get('Vocabulary_Identify')">
        <div class="row">
          <div class="detail-name col-3">
            Words
          </div>
          <div class="col-8">
            <span *ngFor="let desc of mappedDescriptions.get('Vocabulary_Identify');let isLast=last">
              <span>{{ desc }}</span>
              <span *ngIf="!isLast">, </span>
            </span>
          </div>
        </div>
        <hr>
      </div>
      <div *ngIf="mappedDescriptions.get('Phonics_Letters_Identify')">
        <div class="row">
          <div class="detail-name col-3" *ngIf="mappedDescriptions.get('Phonics_Letters_Identify')">
            Letters
          </div>
          <div class="col-8">
            <span *ngFor="let desc of mappedDescriptions.get('Phonics_Letters_Identify');let isLast=last">
              <span>{{ desc }}</span>
              <span *ngIf="!isLast">, </span>
            </span>
          </div>
        </div>
        <hr>
      </div>
      <div *ngIf="mappedDescriptions.get('LanguageStructures_Speaking')">
        <div class="row">
          <div class="detail-name col-3">
            Speaking
          </div>
          <div class="col-8">
            <span *ngFor="let desc of mappedDescriptions.get('LanguageStructures_Speaking');let isLast=last">
              <span>{{ desc }}</span>
              <span *ngIf="!isLast"><br> </span>
            </span>
          </div>
        </div>
        <hr>
      </div>
      <div *ngIf="mappedDescriptions.get('LanguageStructures_Listening')">
        <div class="row">
          <div class="detail-name col-3">
            Listening
          </div>
          <div class="col-8">
            <span *ngFor="let desc of mappedDescriptions.get('LanguageStructures_Listening');let isLast=last">
              <span>{{ desc }}</span>
              <span *ngIf="!isLast"><br> </span>
            </span>
          </div>
        </div>
        <hr>
      </div>

      <div class="row">
        <div class="detail-name col-3">
          Books
        </div>
        <div class="col-8">
          <div *ngFor="let book of unitDetails.Books">
            <ng-container>{{ displaySkillConcept(book) }}</ng-container>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="detail-name col-3">
          Song
        </div>
        <div class="col-8">
          {{ unitDetails.Song }}
        </div>
      </div>
    </div>
  </div>

  <hr class="major-divider">
  <h2 class="mb-0 grey-background legend-header justify-content-between">
    <div>Cycle {{unitDetails.UnitNumber}} Activities</div>
    <div class="legend">
      <div class="activity-rectangle-legend"></div>
      <div class="legend-label">Completed</div>
      <div class="activity-rectangle-has-artifacts activity-rectangle-legend"></div>
      <div class="legend-label">Completed with Student Work</div>
      <div class="activity-rectangle-legend activity-rectangle-unit-test"></div>
      <div class="legend-label">Cycle Test Results</div>
    </div>
  </h2>
  <div class="d-flex m-4 align-items-center activity-list" *ngIf="unitDetails.ActivityResults">
    <div (click)="selectActivity(activity)" 
      *ngFor="let activity of unitDetails.ActivityResults.slice(0,activityListLineBreak) let x = index"
      [ngClass]="{
          'activity-rectangle-base': true,
          'activity-rectangle-first': x == 0, 
          'activity-rectangle-last': x == unitDetails.ActivityResults.length - 1, 
          'activity-rectangle-incompleted': !(activity.IsComplete), 
          'activity-rectangle-selected': isSelected(activity), 
          'activity-rectangle-has-artifacts': !!activity.GeneratedArtifacts && activity.GeneratedArtifacts.length > 0,
          'activity-rectangle-unit-test': activity.InteractionCode === 'CycleTest' && activity.IsComplete
        }">
    </div>
  </div>
  <div class="d-flex m-4 align-items-center activity-list" 
    *ngIf="unitDetails.ActivityResults && unitDetails.ActivityResults.length > activityListLineBreak">
    <div (click)="selectActivity(activity)" 
      *ngFor="let activity of unitDetails.ActivityResults.slice(activityListLineBreak) let x = index"
      [ngClass]="{
          'activity-rectangle-base': true,
          'activity-rectangle-last': x + activityListLineBreak == unitDetails.ActivityResults.length - 1, 
          'activity-rectangle-incompleted': !(activity.IsComplete), 
          'activity-rectangle-selected': isSelected(activity), 
          'activity-rectangle-has-artifacts': !!activity.GeneratedArtifacts && activity.GeneratedArtifacts.length > 0,
          'activity-rectangle-unit-test': activity.InteractionCode === 'CycleTest' && activity.IsComplete
        }">
    </div>
  </div>
  <hr class="major-divider">
  <app-activity-results [activityResult]="selectedActivity" [studentID]="studentID"></app-activity-results>
</ng-template>